import $ from 'jquery';
const now = new Date();
const anonceItem = $('.anonce-item');

$('.nav-anonce li a').click(function (e) {
  e.preventDefault();
  $('.nav-anonce li').removeClass('active_link');
  $(this).parent().addClass('active_link');
});

$('.nav-anonce li a[data-sort="future"]').click(function (e) {
  e.preventDefault();
  anonceItem.each(function () {
    let findDates = $(this).find('.date-end').attr('data-endDate');
    let dates = new Date(`${findDates}`);
    if (dates > now) {
      $(this).addClass('active');
      $(this).removeClass('hide');
    } else {
      $(this).addClass('hide');
      $(this).removeClass('active');
    }
  });
});

$('.nav-anonce li a[data-sort="all"]').click(function (e) {
  e.preventDefault();
  anonceItem.each(function () {
    $(this).addClass('active');
    $(this).removeClass('hide');
  });
});

$('.nav-anonce li a[data-sort="past"]').click(function (e) {
  e.preventDefault();
  anonceItem.each(function () {
    let findDates = $(this).find('.date-end').attr('data-endDate');
    let timestamp = Date.parse(findDates);
    let dates = new Date(timestamp);
    if (dates < now) {
      $(this).addClass('active');
      $(this).removeClass('hide');
    } else {
      $(this).addClass('hide');
      $(this).removeClass('active');
    }
  });
});

$(document).click(function() {
  if($('.active').length === 0) {
    $('.anonce-noresult').show()
  } else {
    $('.anonce-noresult').hide()
  }
})
